var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { FormBase } from './form';
import { clone, isArr } from '@ecom-zform/shared';
import { buildNode, buildNodeArray, disposeFromAndToIndex, exchangeArrayChildren, moveArrayChildren, spliceArrayChildren, } from '../shared/internal';
import { shallowReactive } from '@vue/reactivity';
import { buildLazyCallback, internalLog } from '../shared';
import { watch } from '../watch';
var FormArray = /** @class */ (function (_super) {
    __extends(FormArray, _super);
    function FormArray(props) {
        var _this = _super.call(this, props) || this;
        _this.n = _this.node;
        _this.na = _this.nodeArray;
        _this.children = shallowReactive([]);
        _this._arrayMakeWatch();
        return _this;
    }
    FormArray.prototype._arrayMakeWatch = function () {
        var _this = this;
        watch(function () { return _this.value.value; }, function (newValue) {
            if (isArr(newValue)) {
                var childrenLength = _this.children.length;
                var valLength = newValue.length;
                if (childrenLength !== valLength) {
                    if (valLength > childrenLength) {
                        spliceArrayChildren.apply(void 0, __spreadArray([_this,
                            valLength,
                            0], __read(newValue.slice(childrenLength).map(function (v) { return ({ value: v }); }))));
                    }
                    else {
                        // remove extra children
                        spliceArrayChildren(_this, valLength, childrenLength);
                    }
                }
            }
        }, { immediate: true });
    };
    /**
     * 生成一般类型子节点，path 必须为 number
     * @param path
     */
    FormArray.prototype.node = function (path) {
        return buildNode(this, this.root, path);
    };
    /**
     * 生成数组类型子节点，path 必须为 number
     * @param path
     */
    FormArray.prototype.nodeArray = function (path) {
        return buildNodeArray(this, this.root, path);
    };
    /**
     * 观察 children，当 children 的顺序，长度发生变更时触发 callback
     * @param cb
     * @param options
     */
    FormArray.prototype.watchChildren = function (cb, options) {
        var _this = this;
        var lazyCb = buildLazyCallback(cb);
        return watch(function () { return _this.children.map(function (fc) { return fc.uuid; }); }, function () {
            lazyCb(_this.children);
        }, options);
    };
    /**
     * 用来操作子节点，使用方法类似 Array.splice
     * @param startIndex
     * @param deleteCount
     * @param items
     */
    FormArray.prototype.splice = function (startIndex, deleteCount) {
        var items = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            items[_i - 2] = arguments[_i];
        }
        // 需要 clone 一下 items，避免出现新增的 item 引用地址相同的情况
        var clonedItems = clone(items) || [];
        spliceArrayChildren.apply(void 0, __spreadArray([this, startIndex, deleteCount], __read(clonedItems.map(function (v) { return ({ value: v }); }))));
        var value = clone(this.value.value) || [];
        value.splice.apply(value, __spreadArray([startIndex, deleteCount], __read(items)));
        this.setState({
            value: value,
        }, internalLog('insert set form value', this));
        return this;
    };
    /**
     * 插入子节点，支持一次性传入多个子节点
     * @param startIndex
     * @param items
     */
    FormArray.prototype.insert = function (startIndex) {
        var items = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            items[_i - 1] = arguments[_i];
        }
        return this.splice.apply(this, __spreadArray([startIndex, 0], __read(items)));
    };
    /**
     * 在 children 结尾增加子节点，支持一次性传入多个子节点
     * @param itemsValue
     */
    FormArray.prototype.push = function () {
        var itemsValue = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            itemsValue[_i] = arguments[_i];
        }
        return this.splice.apply(this, __spreadArray([this.children.length, 0], __read(itemsValue)));
    };
    /**
     * 移除子节点，支持同时移除多个子节点
     * @param startIndex
     * @param removeCount
     */
    FormArray.prototype.remove = function (startIndex, removeCount) {
        return this.splice(startIndex, removeCount || 1);
    };
    /**
     * 交换两个节点的位置
     * @param fromIndex
     * @param toIndex
     */
    FormArray.prototype.exchange = function (fromIndex, toIndex) {
        var value = clone(this.state.value) || [];
        var _a = disposeFromAndToIndex(value, fromIndex, toIndex), from = _a.from, to = _a.to;
        exchangeArrayChildren(this, from, to);
        var fromValue = value[from];
        value[from] = value[to];
        value[to] = fromValue;
        this.setState({
            value: value,
        }, internalLog('exchange set form value', this));
        return this;
    };
    /**
     * 将节点从 fromIndex 移动到 toIndex
     * @param fromIndex
     * @param toIndex
     */
    FormArray.prototype.move = function (fromIndex, toIndex) {
        var value = clone(this.value.value) || [];
        var _a = disposeFromAndToIndex(value, fromIndex, toIndex), from = _a.from, to = _a.to;
        moveArrayChildren(this, from, to);
        var _b = __read(value.splice(from, 1), 1), v = _b[0];
        value.splice(to, 0, v);
        this.setState({
            value: value,
        }, internalLog('move set form value', this));
        return this;
    };
    return FormArray;
}(FormBase));
export { FormArray };
